// Module
var code = "<md-toolbar md-theme=\"dark\" class=\"ng-hide abm-search-bar\" ng-show=\"shown\"> <div class=\"md-toolbar-tools\"> <md-input-container flex md-theme=\"black\" class=\"md-accent\" md-no-float> <input type=\"text\" ng-model=\"searchText\" placeholder=\"Search...\"/> </md-input-container> </div> </md-toolbar> ";
// Exports
module.exports = code;